<template>
  <div :style="{'height':sumHeight + 'px'}" ref="pages">
  <div class="home-page" ref="myElement" :style="{ 'transform': 'scale(' + scale + ')','width': (100 / scale) + '%'}">
    <!-- 头部导航 -->
    <div class="header-box" :style="{ 'top': offsetTop / scale + 'px' }">
      <div class="header">
        <nav class="navbar">
          <div>
            <img src="../../static/img/nlogo.png" alt="" class="logo" >
            <img src="../../static/img/logo_title.png" alt="Logo" class="logo" />
          </div>
          <ul class="menu nav nav-underline">
            <li
              class="nav-item"
              :class="{ active: active === 1 }"
              @click="setActive(1, 'home-page')"
            >
              首页
            </li>
            <li
              class="nav-item"
              :class="{ active: active === 2 }"
              @click="setActive(2, 'company-profile')"
            >
              关于我们
            </li>
            <li
              class="nav-item"
              :class="{ active: active === 3 }"
              @click="setActive(3, 'product-categories')"
            >
              平台品类
            </li>
            <li
              class="nav-item"
              :class="{ active: active === 4 }"
              @click="setActive(4, 'operations-management')"
            >
              经营理念
            </li>
            <!-- <li class="nav-item" :class="{ active: active === 5 }" @click="setActive(5, 'platform-brands')">商品厂家</li> -->
          </ul>
        </nav>
      </div>
    </div>
    <!-- 轮播图 -->
    <div class="carousel">
      <div class="swiper-container" id="mySwiper">
        <div class="swiper-wrapper">
          <div
            class="swiper-slide"
            v-for="(banner, index) in banners"
            :key="index"
          >
            <img class="swiper-img" :src="banner.imgUrl" alt="" />
          </div>
        </div>
        <!-- 分页器 -->
        <div class="swiper-pagination"></div>
        <!-- 导航按钮 -->
        <!-- <div class="swiper-button-prev"></div> -->
        <!-- <div class="swiper-button-next"></div> -->
      </div>
      <!-- <h1 class="title animated fadeInUp">别样正品购 体验新感受</h1> -->
    </div>

    <!-- 公司介绍 -->
    <section class="company-profile">
      <div class="company-profile-title">
        <p class="company-profile-title-cn">公司介绍</p>
        <p class="company-profile-title-en">Company Profile</p>
      </div>
      <!-- 更多内容... -->
      <div class="company-profile-content">
        <div class="company-profile-row">
          <p class="company-profile-span">
            淘街优品会由淘街电子商务科技（广州）有限公司运营，创立于2025年，位于广州。
          </p>
          <p class="company-profile-span">
            作为新一代全品类品质电商平台，我们以“严选全球优品，定义品质生活”为核心理念，聚焦服饰美妆、数码家电、家居生活等全品类赛道，构建覆盖商品全生命周期的品质消费生态圈。
          </p>
          <p class="company-profile-span">
            在电商行业告别低价内卷的2025年，淘街优品会倡导“理性消费，只买好东西”的新消费观，致力于成为消费者心中“闭眼入”的品质购物首选。
          </p>
        </div>
      </div>
    </section>

    <!-- 我们的品类 -->
    <section class="product-categories">
      <div class="product-categories-title">
        <div class="product-categories-title-cn">
          <div class="product-categories-title-cn-first">我们的品类</div>
          <div class="product-categories-title-cn-second">全品类的高质商品</div>
        </div>
        <div class="product-categories-title-en">
          <div class="product-categories-title-en-first">
            Our Product Categori
          </div>
          <div class="product-categories-title-en-second">
            致力于为消费者提供覆盖全品类的高质商品，同时极具竞争力的价格，让实惠与品质兼得。
          </div>
        </div>
      </div>
      <div class="swiper-container cataegory-swiper" id="mySwiperSlide">
        <div class="swiper-wrapper">
          <div
            class="swiper-slide"
            v-for="(categories, index) in categorys"
            :key="index"
          >
            <div class="category-grid">
              <div
                v-for="(item, cidx) in categories"
                class="category-item"
                :key="cidx"
                :style="{
                  'background-image': 'url(' + item.img + ')',
                  opacity: item.hidebox ? '0' : '1',
                }"
              >
                <div class="category-item-mask">{{ item.name }}</div>
              </div>
              <!-- 更多分类... -->
            </div>
          </div>
        </div>
        <!-- 分页器 -->
        <div class="swiper-pagination"></div>
        <!-- 导航按钮 -->
        <!-- <div class="swiper-button-prev"></div> -->
        <!-- <div class="swiper-button-next"></div> -->
      </div>
    </section>

    <!-- 经营管理 -->
    <section class="operations-management">
      <div class="operations-management-title">
        <p class="operations-management-title-cn">经营管理</p>
        <p class="operations-management-title-en">Operations And Management</p>
      </div>
      <div class="operations-management-content">
        <div
          class="operations-management-content-row"
          v-for="(item, index) in operations"
          :key="index"
        >
          <div
            class="operations-management-content-row-left"
            :class="{ order1: index % 2 !== 0, 'flex-end': index % 2 !== 0 }"
          >
            <div class="operations-management-content-row-left-text">
              {{ item.text }}
            </div>
          </div>
          <div
            class="operations-management-content-row-right"
            :class="{ order1: index % 2 === 0 }"
          >
            <img
              class="operations-management-content-row-right-img"
              :src="item.img"
              alt=""
            />
          </div>
        </div>
        <!-- <img src="@/assets/image1.jpg" alt="Image 1" /> -->
        <!-- <img src="@/assets/image2.jpg" alt="Image 2" /> -->
        <!-- 更多图片... -->
      </div>
      <!-- 更多内容... -->
    </section>

    <!-- 核心定位 -->
    <section class="core-positioning">
      <div class="core-positioning-title">
        <div class="core-positioning-title-cn">
          <div class="core-positioning-title-cn-first">核心定位</div>
          <div class="core-positioning-title-cn-second">
            《淘街-优品会》—营造100%正品购物环境是我存在的意义！
          </div>
        </div>
        <div class="core-positioning-title-en">
          <div class="core-positioning-title-en-first">Core Positioning</div>
        </div>
      </div>
      <div
        class="core-positioning-content"
        :style="{ 'background-image': 'url(' + core + ')' }"
      >
        <!-- 作为新一代全品类品质电商平台，《淘街-优品会》以"严选全球优品，定义品质生活"为核心理念，构建覆盖服饰美妆、数码家电、家居生活等全品类的品质消费生态圈。平台通过独创的"三级品控体系"，严格筛选入驻商家与商品，致力于成为消费者心中"闭眼入"的品质购物首选。 -->

        【品质与实惠的共生之地】作为全品类精选电商平台，我们始终以
        “高品质、优价格” 为核心，为消费者打造一站式放心购体验。
        从家居百货到数码美妆，从生鲜食品到服饰箱包，平台严选全球优质供应商，通过直采直供砍掉中间环节，既确保每款商品经过资质审核与质量检测，又以规模化优势实现
        “同品质价更低”。
        我们承诺会坚持营造100%正品购物环境、七天无理由退换，更有日常折扣、会员专享价等持续让利。成立至今，始终践行
        “让高品质生活触手可及” 的初心，成为千万用户心中 “放心买、划算购”
        的首选平台。
      </div>
      <!-- 更多内容... -->
    </section>

    <!-- 品质壁垒 -->
    <section class="quality-barrier">
      <div class="quality-barrier-title">
        <p class="quality-barrier-title-cn">品质壁垒</p>
        <p class="quality-barrier-title-en">Quality Barrier</p>
      </div>
      <div class="quality-barrier-content">
        <div
          class="quality-barrier-content-row"
          :style="{ 'background-image': 'url(' + qualityimg + ')' }"
          v-for="(item, index) in qualitys"
          :key="index"
        >
          <div class="title-text">{{ item.title }}</div>
          <div class="title-content" v-html="item.content"></div>
        </div>
      </div>
      <!-- 更多内容... -->
    </section>

    <!-- 创新体验 -->
    <section class="innovative-experience">
      <div class="innovative-experience-title">
        <p class="innovative-experience-title-cn">创新体验</p>
        <p class="innovative-experience-title-en">Innovative Experience</p>
      </div>
      <div class="innovative-experience-content">
        <div
          class="innovative-experience-content-row"
          :style="{ 'background-image': 'url(' + innovativeimg + ')' }"
          v-for="(item, index) in experienceList"
          :key="index"
        >
          <div class="title-text">{{ item.title }}</div>
          <div class="title-content">{{ item.content }}</div>
        </div>
      </div>
      <!-- 更多内容... -->
    </section>
    <!-- 价值主张 -->
    <section class="value-proposition">
      <div class="value-proposition-title">
        <div class="value-proposition-title-cn">价值主张</div>
        <div class="value-proposition-title-en">Value Proposition</div>
      </div>
      <div
        class="value-proposition-content"
        :style="{ 'background-image': 'url(' + propositionimg + ')' }"
      >
        <div class="value-proposition-content-text">
          《淘街-优品会》倡导"理性消费，只买好东西"的新消费观。通过建立"平台严选+品牌直供+用户监督"的品质闭环，既保障消费者权益，又为优质商家提供可持续发展的生态空间。
        </div>
        <img
          class="value-proposition-content-img"
          :src="propositionContent"
          alt=""
        />
      </div>
      <!-- 更多内容... -->
    </section>

    <!-- 平台商品品牌 -->
    <!-- <section class="platform-brands">
      <div class="platform-brands-title">
        <div class="platform-brands-title-cn">
          平台商品品牌
        </div>
        <div class="platform-brands-title-en">
          Platform Product Brand
        </div>
      </div>
      <div class="platform-brands-content">
        <div class="platform-brands-content-row" v-for="(item, index) in 14" :key="index">
          <img :src="brandLogo" alt="" />
        </div>
      </div>
    </section> -->
    <div class="footer">
      <div class="footer-row">
        <img
          class="footer-row-img"
          referrerpolicy="no-referrer"
          src="../../static/img/logo_footer.png"
        />
        <div class="footer-row-text">
          <div>淘街电子商务科技（广州）有限公司</div>
          <div>地址：广州市白云区鹤龙街尖彭路397号天瑞广场A座1101号</div>
          <div>电话：13275792261</div>
          <div>邮箱：2547775618@qq.com</div>
        </div>
        <div class="footer-row-text2">
          <!-- <div>【下载即享】</div>
          <div>
            新用户注册立享199元品质礼包，首单满299元赠"品质体验官"特权，可优先参与新品内测与线下品鉴会。现在下载，开启你的品质消费新范式！
          </div> -->
        </div>
        <div class="flex">
          <!-- <div class="footer-row-wechat">
            <img class="wx-img" src="../../static/img/download/wechat.jpg" />
            <span class="wx-text">微信公众号</span>
          </div> -->
          <div class="footer-row-wechat">
            <img class="wx-img" src="../../static/img/download/wechat-xcx.jpg" />
            <span class="wx-text">微信小程序</span>
          </div>
          <!-- <div class="footer-row-wechat">
            <img class="wx-img" src="../../static/img/download/apk.png" />
            <span class="wx-text">APP下载</span>
          </div> -->
        </div>
      </div>
      <div class="footer-row-icp">
        <p class="beloned">&copy; 2025 广州淘街电子商务科技有限公司 版权所有</p>
        <p class="colorwhite">
          备案号：
          <a
            href="https://beian.miit.gov.cn/"
            target="_blank"
            class="colorwhite"
          >
            粤ICP备2021124029号-3
          </a>
        </p>
      </div>
    </div>
    <!-- 底部信息 -->
  </div>
  <ScrollToTopButton v-show="isVisible" :style="{ 'transform': 'scale(' + scale + ')'}"/>
  </div>
</template>

<script>
// import VConsole from "vconsole";
// const newconsole = new VConsole();
import Swiper from "swiper";
import ScrollToTopButton from "../components/ScrollToTopButton.vue";
const banner = require("../../static/img/banner.png");
const banner1 = require("../../static/img/banner1.png");
const banner2 = require("../../static/img/banner2.png");
//分类图片
// const guoshu = require('../../static/img/guoshu.png');
// const shuma = require('../../static/img/shuma.png');
// const jiaju = require('../../static/img/jiaju.png');
// const shiwu = require('../../static/img/shiwu.png');
// const fuzhuang = require('../../static/img/fuzhuang.png');
// const mengchon = require('../../static/img/mengchon.png');

const chuju = require("../../static/img/chuju.png");
const fushineiyi = require("../../static/img/fushineiyi.png");
const gerenhuli = require("../../static/img/gerenhuli.png");
const huwaiyundong = require("../../static/img/huwaiyundong.png");
const jiajuriyon = require("../../static/img/jiajuriyon.png");
const jiatingqinjie = require("../../static/img/jiatingqinjie.png");
const jiayondianqi = require("../../static/img/jiayondianqi.png");
const jiulei = require("../../static/img/jiulei.png");
const meizhuanghufu = require("../../static/img/meizhuanghufu.png");
const shengxian = require("../../static/img/shengxian.png");
const shipinyinliao = require("../../static/img/shipinyinliao.jpg");
const shumachanpin = require("../../static/img/shumachanpin.png");
const yingyanbaojian = require("../../static/img/yingyanbaojian.png");
const zhubaoshoushi = require("../../static/img/zhubaoshoushi.png");
//经营理念配图
//const operations01 = require('../../static/img/operations01.png');
//const operations02 = require('../../static/img/operations02.png');
//const operations03 = require('../../static/img/operations03.png');
const operations01 = require("../../static/img/operations04.png");
const operations02 = require("../../static/img/operations05.png");
const operations03 = require("../../static/img/operations06.png");

//const propositionContent = require('../../static/img/proposition_content.png');
const propositionContent = require("../../static/img/proposition_content3.png");

//核心定位
const core = require("../../static/img/core.png");

//品质壁垒
const qualityimg = require("../../static/img/quality.png");
//创新体验
const innovativeimg = require("../../static/img/innovative.png");
//价值主张
const propositionimg = require("../../static/img/proposition.png");
//
const brandLogo = require("../../static/img/brand_logo.png");

export default {
  components: {
    ScrollToTopButton,
  },
  data() {
    return {
      categorys: [
        [
          {
            name: "家居日用",
            img: jiajuriyon,
          },
          {
            name: "家用电器",
            img: jiayondianqi,
          },
          {
            name: "数码产品",
            img: shumachanpin,
          },
          {
            name: "服饰内衣",
            img: fushineiyi,
          },
          {
            name: "美妆护肤",
            img: meizhuanghufu,
          },
          {
            name: "生鲜",
            img: shengxian,
          },
        ],
        [
          {
            name: "户外运动",
            img: huwaiyundong,
          },
          {
            name: "酒类",
            img: jiulei,
          },
          {
            name: "家庭清洁",
            img: jiatingqinjie,
          },
          {
            name: "珠宝首饰",
            img: zhubaoshoushi,
          },
          {
            name: "营养保健",
            img: yingyanbaojian,
          },
          {
            name: "个人护理",
            img: gerenhuli,
          },
        ],
        [
          {
            name: "厨具",
            img: chuju,
          },
          {
            name: "食品饮料",
            img: shipinyinliao,
          },
          {
            hidebox: true,
          },
        ],
      ],
      operations: [
        {
          text: "作为全品类精选电商平台，我们始终以 “高品质、优价格” 为核心，为消费者打造一站式放心购体验。",
          img: operations01,
        },
        {
          text: "从家居百货到数码美妆，从生鲜食品到服饰箱包，平台严选全球优质供应商，通过直采直供砍掉中间环节，既确保每款商品经过资质审核与质量检测，又以规模化优势实现 “同品质价更低”。",
          img: operations02,
        },
        {
          text: " 我们承诺 100% 正品保障、七天无理由退换，更有日常折扣、会员专享价等持续让利。成立至今，始终践行 “让高品质生活触手可及” 的初心，成为千万用户心中 “放心买、划算购” 的首选平台。",
          img: operations03,
        },
      ],
      qualitys: [
        {
          title: "准入机制",
          content:
            "拥有完整品牌授权链的优质企业，要求商家提供近三年无重大质量事故证明，化妆品类目需额外提交非特备案凭证，食品类目需提供SC认证及第三方质检报告。",
        },
        {
          title: "动态监管",
          content:
            '每月随机抽检在售商品，引入SGS、ITS等国际权威检测机构进行盲测，对连续两次抽检不合格的商家启动"熔断机制"，并列入行业黑名单。',
        },
        {
          title: "品质溯源",
          content:
            '通过区块链技术实现商品全生命周期溯源，扫描商品二维码即可查看原料采购、生产工艺、质检报告等20余项关键信息，真正做到"一品一码，全程可溯"。',
        },
      ],
      experienceList: [
        {
          title: "智能选品系统",
          content:
            '基于用户消费行为数据，结合AI算法推荐"品质指数"，将商品从设计、工艺、环保等维度量化评分，帮助用户快速锁定高性价比优品。',
        },
        {
          title: "场景化购物",
          content:
            '首创"品质生活实验室"频道，通过短视频、直播等形式呈现商品实测场景。例如:家居用品可预约VR实景体验。',
        },
        {
          title: "无忧服务体系",
          content:
            "- 7天无理由退换货（含穿戴类商品）\n - 专属客服团队7×24小时响应\n - 引入太平洋保险提供正品险，假一赔十\n ",
        },
      ],
      slides: [
        {
          // image: require('@/assets/slide1.jpg')
        },
        {
          // image: require('@/assets/slide2.jpg')
        },
        // 更多轮播图...
      ],
      brands: [],
      // 图片引入
      core,
      qualityimg,
      innovativeimg,
      propositionimg,
      propositionContent,
      brandLogo,
      active: 1,
      banners: [
        { imgUrl: banner },
        { imgUrl: banner1 },
        { imgUrl: banner2 },

        // { imgUrl: banner },
      ], // 轮播图数据
      mySwiper: null, // 用于保存Swiper实例
      mySwiperSlide: null, // 用于保存SwiperSlide实例
      scale: 1, // 页面缩放比例
      sumHeight:1000,
      isVisible: false,
      offsetTop:0,
    };
  },
  created() {
    // 获取屏幕宽度，计算缩放比例
    console.log("created");
    this.setSale();
    window.addEventListener("resize", this.setSale);
  },
  mounted() {
    // 模拟从后端获取数据
    this.$nextTick(() => {
      this.initSwiper(); // 初始化Swiper
      this.initSwiperSlide(); // 初始化SwiperSlide
      this.getHeight();
      const el = this.$refs.pages;
      console.log(el)
      if (el) {
        // 绑定 scroll 事件
        // el.addEventListener('scroll', this.handleScroll);
        window.addEventListener('scroll', this.handleScroll);
      }
    });
  },
  beforeDestroy() {
    // 组件销毁前移除事件，避免内存泄漏
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      console.log(window.pageYOffset);
      this.offsetTop = window.pageYOffset;
      this.isVisible = window.pageYOffset > 600;
    },
    getHeight() {
      const el = this.$refs.myElement;
      if (el) {
        const height = el.offsetHeight; // 包含 padding 和 border
        // 或者：
        // const height = el.clientHeight; // 包含 padding，不包含 border
        // const height = el.scrollHeight; // 内容实际高度，包含溢出
        this.sumHeight = height * this.scale;
        console.log("sumHeight", this.sumHeight);

        // this.$refs.myElement.style.height = this.sumHeight + "px";
        console.log('元素高度:', height + 'px');
      }
    },
    setSale() {
      const clientWidth = document.documentElement.clientWidth;
      if (clientWidth > 1440) {
        this.scale = 1;
      } else if (clientWidth < 1440) {
        this.scale = clientWidth / 1440;
      }
      console.log("this.scale", this.scale);
    },
    initSwiper() {
      if (this.mySwiper) {
        this.mySwiper.destroy(); // 销毁旧的Swiper实例
      }
      this.mySwiper = new Swiper("#mySwiper", {
        loop: true, // 循环模式
        pagination: {
          el: ".swiper-pagination", // 分页器
          bulletClass: "my-bullet", //需设置.my-bullet样式
          bulletActiveClass: "my-bullet-active",
          clickable: true,
        },
        autoplay: {
          pauseOnMouseEnter: true,
          disableOnInteraction: false,
          delay: 4000,
        },
        on: {
          autoplayPause: function () {
            console.log("自动切换暂停了");
          },
          autoplayResume: function () {
            console.log("自动切换恢复了");
          },
        },
      });
    },
    initSwiperSlide() {
      if (this.mySwiperSlide) {
        this.mySwiperSlide.destroy(); // 销毁旧的SwiperSlide实例
      }
      this.mySwiperSlide = new Swiper("#mySwiperSlide", {
        loop: true, // 循环模式
        pagination: {
          el: ".swiper-pagination", // 分页器
          clickable: true,
          bulletClass: "my-bullet", //需设置.my-bullet样式
          bulletActiveClass: "my-bullet-active",
        },
        autoplay: {
          pauseOnMouseEnter: true,
          disableOnInteraction: false,
          delay: 4000,
        },
      });
    },
    setActive(index, elementId) {
      this.active = index;
      const element = document.getElementsByClassName(elementId);
      if (element && element.length > 0) {
        element[0].scrollIntoView({ behavior: "smooth" }); // 平滑滚动到元素位置
        // 或者使用 window.scrollTo 来滚动到元素的顶部
        // window.scrollTo({ top: element.offsetTop, behavior: 'smooth' });
      }
    },
  },
  watch: {
    // banners() {
    //   // 监听banners数据变化
    //   this.$nextTick(() => {
    //     this.initSwiper(); // 初始化Swiper
    //     this.initSwiperSlide(); // 初始化SwiperSlide
    //   });
    // },
  },
};
</script>

<style lang="less" scoped>
/* 样式部分 */
.home-page {
  font-size: 16px;
  font-family: Arial, sans-serif;
  max-width: 1440px;
  overflow-x: hidden;
  margin: 0 auto;
  transform-origin: 0 0; /* 设置缩放原点 */
  padding-top: 106px;
}

.header-box {
  width: 100%;
  height: 106px;
  position: absolute;
}

.header {
  position: relative;
  top: 0;
  width: 100%;
  max-width: 1440px;
  z-index: 1000;
  top: 0;
  background-color: #ffffff;
  border-bottom: 1px solid #e2e2e2;
  box-shadow: 0 2px rgba(0, 0, 0, 0.04);
  height: 106px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
}

.navbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0;
  width: 100%;
  height: 100%;
}

.logo {
  height: 70px;
  width: auto;
  cursor: pointer;
}

.menu {
  height: 100%;
  display: flex;
  align-items: center;

  li {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    cursor: pointer;
    margin: 0 20px;
    width: fit-content;
    font-weight: 600;
  }

  :hover {
    color: #f10000;
    position: relative;
  }

  .active {
    color: #f10000;
  }

  .active::after {
    content: "";
    display: block;
    background-color: #f10000;
    // width: 40px;
    width: 100%;
    height: 4px;
    position: absolute;
    bottom: 0;
  }
}

.carousel {
  position: relative;
}

.title {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: white;
  font-size: 32px;
}

.company-profile,
.product-categories,
.operations-management,
.core-positioning,
.quality-barrier,
.innovative-experience,
.value-proposition,
.platform-brands {
  // padding: 2rem;
  text-align: center;
}

// 公司介绍
.company-profile {
  padding-top: 200px;
  font-family: "dingding Regular";
  &-title {
    margin: 0 13%;
    text-align: left;

    &-cn {
      font-size: 54px;
      font-weight: normal;
      color: #f10000;
      line-height: 57px;
    }

    &-en {
      margin: 10px;
      font-size: 24px;
      color: #f10000;
    }
  }

  &-content {
    height: 536px;
    width: 100%;
    max-width: 1440px;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-image: url("../../static/img/profile.png");
    position: relative;
  }

  &-row {
    position: absolute;
    width: 580px;
    left: 13%;
    top: 20px;
  }

  &-span {
    font-size: 17px;
    line-height: 23px;
    color: #000;
    margin-bottom: 26px;
    text-align: left;
  }
}

// 品类
.product-categories {
  font-family: "dingding Regular";
  padding-top: 200px;

  &-title {
    margin: 0 13%;
    text-align: left;

    &-cn {
      display: flex;
      align-items: center;
      font-size: 52px;
      font-weight: normal;
      color: #f10000;
      line-height: 57px;

      &-first {
        width: 270px;
      }

      &-second {
        height: 38px;
        line-height: 38px;
        padding: 0 30px;
        border-radius: 20px;
        background-color: #f10000;
        color: #ffffff;
        font-size: 23px;
        margin-left: 30px;
      }
    }

    &-en {
      display: flex;
      align-items: center;
      font-size: 24px;
      color: #f10000;
      margin: 10px;
      white-space: nowrap;

      &-first {
        width: 270px;
      }

      &-second {
        color: #000;
        font-size: 18px;
        margin-left: 30px;
        white-space: nowrap;
      }
    }
  }
}

// 经营管理
.operations-management {
  font-family: "dingding Regular";
  padding-top: 160px;

  &-title {
    margin: 0 13%;
    text-align: left;

    &-cn {
      font-size: 54px;
      font-weight: normal;
      color: #f10000;
      line-height: 57px;
    }

    &-en {
      font-size: 24px;
      color: #f10000;
      margin: 10px;
    }
  }

  &-content {
    &-row {
      width: 100%;
      display: flex;
      justify-content: center;

      &-left {
        width: 518px;
        height: 345px;
        display: flex;
        align-items: center;
        justify-content: flex-start;

        &-text {
          width: 400px;
          font-size: 16px;
          color: #333333;
          line-height: 28px;
          text-align: left;
        }
      }

      &-right {
        width: 518px;
        height: 345px;
        transition: all 0.5s ease-in-out;
        &-img {
          max-width: 100%;
          width: 100%;
          height: auto;
        }
      }
      :hover {
        transform: scale(1.05);
        transition: all 0.5s ease-in-out;
      }

      .order1 {
        order: 1;
      }

      .flex-end {
        justify-content: flex-end;
      }
    }
  }
}

// 品类
.core-positioning {
  font-family: "dingding Regular";
  margin-top: 260px;

  &-title {
    margin: 0 13%;
    text-align: left;

    &-cn {
      display: flex;
      align-items: center;
      font-size: 52px;
      font-weight: normal;
      color: #f10000;
      line-height: 57px;

      &-first {
        width: 270px;
      }

      &-second {
        height: 38px;
        line-height: 38px;
        padding: 0 30px;
        border-radius: 20px;
        background-color: #f10000;
        color: #ffffff;
        font-size: 23px;
        margin-left: 30px;
      }
    }

    &-en {
      display: flex;
      align-items: center;
      font-size: 24px;
      color: #f10000;
      margin: 10px;
      &-first {
        width: 270px;
      }

      &-second {
        color: #000;
        font-size: 18px;
        margin-left: 30px;
      }
    }
  }

  &-content {
    margin: 0 11%;
    width: 78%;
    padding: 60px;
    font-size: 16px;
    text-align: left;
    color: #333333;
    line-height: 28px;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    transition: all 0.5s ease-in-out;
  }
  &-content:hover {
    transform: scale(1.05);
    transition: all 0.5s ease-in-out;
    color: #000000;
  }
}

//品质壁垒
.quality-barrier {
  font-family: "dingding Regular";
  &-title {
    margin: 0 13%;
    text-align: left;

    &-cn {
      font-size: 54px;
      font-weight: normal;
      color: #f10000;
      line-height: 57px;
    }

    &-en {
      font-size: 24px;
      color: #f10000;
      margin: 10px;
    }
  }

  &-content {
    display: flex;
    align-items: center;
    justify-content: center;

    &-row {
      width: 357px;
      height: 321px;
      background-size: 100% 100%;
      background-repeat: no-repeat;

      .title-text {
        height: 24px;
        font-size: 24px;
        color: #333333;
        line-height: 24px;
        text-align: center;
        margin: 70px 0 45px 0;
      }

      .title-content {
        width: 300px;
        margin: 0 auto;
        font-size: 16px;
        color: #333333;
        line-height: 28px;
        text-align: justify;
      }
    }
    &-row:hover {
      transform: scale(1.01);
      box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.2);
      border-radius: 10px;
      .title-content {
        color: #000000;
      }
    }
  }
}

//创新体验
.innovative-experience {
  font-family: "dingding Regular";
  padding-top: 120px;
  &-title {
    margin: 0 13%;
    text-align: left;

    &-cn {
      font-size: 54px;
      font-weight: normal;
      color: #f10000;
      line-height: 57px;
    }

    &-en {
      font-size: 24px;
      color: #f10000;
      margin: 10px;
    }
  }

  &-content {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    &-row {
      // width: 357px;
      width: 78%;
      height: 176px;
      background-size: 100% 100%;
      background-repeat: no-repeat;
      display: flex;
      align-items: center;

      .title-text {
        height: 24px;
        font-size: 24px;
        color: #333333;
        line-height: 24px;
        text-align: center;
        margin: 0 36px 0 75px;
      }

      .title-content {
        width: 660px;
        margin: 0 auto;
        font-size: 16px;
        color: #333333;
        line-height: 28px;
        text-align: justify;
        white-space: pre-line;
        /* 保留换行符并自动换行 */
      }
    }
    &-row:hover {
      transform: scale(1.01);
      box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.2);
      border-radius: 10px;
      .title-content {
        color: #000000;
      }
    }
  }
}

// 价值主张
.value-proposition {
  font-family: "dingding Regular";
  padding-top: 120px;
  &-title {
    margin: 0 13%;
    text-align: left;

    &-cn {
      font-size: 54px;
      font-weight: normal;
      color: #f10000;
      line-height: 57px;
    }

    &-en {
      margin: 10px;
      font-size: 24px;
      color: #f10000;
    }
  }

  &-content {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 76%;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    margin: 0 auto;
    padding: 60px 50px 50px 50px;

    &-text {
      // width: 90%;
      font-size: 17px;
      color: #333333;
      line-height: 28px;
      text-align: left;
    }

    &-img {
      width: 978px;
      height: auto;
    }
  }
}

// 平台商品品牌
.platform-brands {
  font-family: "dingding Regular";
  padding-top: 160px;

  &-title {
    margin: 0 13%;
    text-align: left;

    &-cn {
      font-size: 54px;
      font-weight: normal;
      color: #f10000;
      line-height: 57px;
    }

    &-en {
      margin: 10px;
      font-size: 24px;
      color: #f10000;
    }
  }

  &-content {
    display: grid;
    grid-template-columns: repeat(5, 0fr);
    grid-gap: 0;
    width: 76%;
    margin: 40px auto;

    &-row {
      width: 215px;
      height: 112px;
    }
  }
}

//底部栏
.footer {
  display: flex;
  flex-direction: column;
  justify-content: center;
  background: radial-gradient(127% 46% at 50% 4%, #2c2c2c 0%, #000000 100%);
  padding: 80px 0 100px 0;
  width: 100%;
  // transform: translateX(calc((100vw - 1440px) / -2));
  &-row {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;

    &-img {
      width: 52px;
      height: 52px;
      margin: 0 20px;
      transition: all 1s ease-in-out;
      :hover {
        transform: scale(1.3);
        transition: all 1s ease-in-out;
      }
    }

    &-text {
      margin: 0 20px;
      width: 280px;
      display: flex;
      flex-direction: column;
      text-align: left;
      font-weight: 400;
      font-size: 13px;
      color: #a3a3a3;
      line-height: 25px;
      cursor: pointer;
    }

    &-text2 {
      margin: 0 20px;
      width: 388px;
      text-align: left;
      font-weight: 400;
      font-size: 13px;
      color: #a3a3a3;
      line-height: 25px;
      cursor: pointer;
    }

    &-wechat {
      // margin: 0 20px;
      width: 100px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      .wx-img {
        width: 86px;
        height: 86px;
        transition: all 1s ease-in-out;
        :hover {
          transform: scale(1.3);
          transition: all 1s ease-in-out;
        }
      }

      .wx-text {
        font-weight: 400;
        font-size: 13px;
        color: #a3a3a3;
        line-height: 25px;
        text-align: left;
        margin-top: 10px;
      }
    }

    &-icp {
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 400;
      font-size: 13px;
      color: #a3a3a3;
      line-height: 12px;
      margin-top: 80px;

      .beloned {
        margin: 0 10px;
      }

      .colorwhite {
        color: #fff;
      }

      .colorwhite:hover {
        color: #f0dd00;
      }
    }
  }
}

// 分类列表
.category-grid {
  display: grid;
  grid-template-columns: repeat(3, 0fr);
  grid-gap: 12px;
  justify-content: center;

  .category-item {
    transition: all 0.4s ease-in-out;
    width: 340px;
    height: 225px;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    border-radius: 10px;
    overflow: hidden;
    
    &-mask {
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.2);
      color: #ffffff;
      font-size: 24px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
  }
  :hover {
    transform: scale(1.1);
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
    transition: all 0.4s ease-in-out;
  }
}

// 轮播图
.swiper-container {
  width: 100%;
  height: 480px;
  background-color: #ffffff;
}

.cataegory-swiper {
  width: 100%;
  height: 540px;
  padding: 10px 0;
  background-color: #ffffff;
}

.swiper-slide {
  display: flex;
  justify-content: center;
  align-items: flex-start;
}

.swiper-slide img {
  width: 100%;
  max-width: 1440px;
  height: auto;
  object-fit: cover;
}

// @media screen and (max-width: 768px) {
//   .home-page{
//     max-width: 768px;
//   }
//   .header{
//     max-width: 768px;
//   }
// }
</style>
<style>
/* // 轮播图 */

.my-bullet {
  display: inline-block;
  border-radius: 50%;
  margin: 0 15px;
  background: #e4e4e4;
  opacity: 1;
  width: 15px;
  height: 15px;
}

.my-bullet-active {
  background: #f10000;
  opacity: 1;
}
.flex{
  display: flex;
}
</style>



// WEBPACK FOOTER //
// src/home/index.vue